export default () => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'waybillNo',
    title: '运单编号',
    width: 130,
    sortable: true,
    showOverflow: true,
  },
  {
    field: 'deliveryAddress',
    title: '发货地址',
    minWidth: 220,
    sortable: true,
    showOverflow: true,
  },
  {
    field: 'receivingAddress',
    title: '收货地址',
    minWidth: 220,
    sortable: true,
    showOverflow: true,
  },
]
